<template>
  <v-container>
    <el-container v-loading.fullscreen.lock="loading">
      <el-header height="auto">
        <el-row type="flex" align="middle">
          <el-col>
            <el-form size="small" inline @keypress.enter.native="reload">
              <el-form-item label="模板名称">
                <el-input v-model.trim="form.name" placeholder="输入模板名称查询" clearable style="width: 160px;"></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model.trim="form.userPhone" placeholder="输入手机号查询" clearable style="width: 160px;"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="reload">搜索</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <el-table :data="list" :row-class-name="tableRowClassName">
          <el-table-column prop="name" label="名称" width="220" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="模板图片" width="200" align="center">
            <template slot-scope="scope">
              <file-image style="max-width: 100%; height: 100px;" fit="contain" :src="scope.row.avatar" />
            </template>
          </el-table-column>
          <el-table-column label="模版文件" width="140" align="center">
            <template slot-scope="scope">
              <file-download-button :src="scope.row.fileKey" />
            </template>
          </el-table-column>
          <el-table-column prop="width" label="宽度" width="100" align="center"></el-table-column>
          <el-table-column prop="height" label="高度" width="100" align="center"></el-table-column>
          <el-table-column prop="lastUsageDate" label="最后使用日期" min-width="180" align="center" :formatter="row => $date.format('yyyy-MM-dd hh:mm:ss', row.lastUsageDate)"></el-table-column>
          <el-table-column prop="updatedDate" label="更新日期" min-width="180" align="center" :formatter="row => $date.format('yyyy-MM-dd hh:mm:ss', row.updatedDate)"></el-table-column>
          <el-table-column prop="deleted" label="状态" width="140" align="center" :formatter="row => DEL_STATUS.get(row.deleted)"></el-table-column>
          <el-table-column label="操作" width="140" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="setOfficial(scope.row)">设为官方模版</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="40px">
        <el-row type="flex" align="middle" justify="center">
          <el-pagination :current-page="page"  :total="total" :page-size="size" layout="slot, prev, pager, next, jumper" @current-change="handleCurrentChange">
            <span>
              共<span class="total">{{total}}</span>条
            </span>
          </el-pagination>
        </el-row>
      </el-footer>
    </el-container>
    <v-edit-dialog :visible="editDialogVisible" :item="item" @close="editDialogVisible = false" @update="reload"></v-edit-dialog>
    <v-official-template-dialog :visible="officialTemplateDialogVisible" :item="item" @close="officialTemplateDialogVisible = false" @update="reload"></v-official-template-dialog>
  </v-container>
</template>

<script>

import MainLayout from '@/components/layout/main-header_main_footer'
import EditDialog from './edit-dialog'
import OfficialTemplateDialog from '@/views/official-templates/templates/edit-dialog'
import { GET_USER_TEMPLATES } from '@/utils/api'
import { DEL_STATUS } from '@/utils/global-constant'

export default {
  name: 'UserTemplateList',

  components: {
    'v-container': MainLayout,
    'v-edit-dialog': EditDialog,
    'v-official-template-dialog': OfficialTemplateDialog
  },

  data () {
    return {
      form: { name: '', userPhone: '' },
      DEL_STATUS,
      page: 1,
      size: 20,
      total: 0,
      loading: false,
      editDialogVisible: false,
      officialTemplateDialogVisible: false,
      item: {},
      list: []
    }
  },

  watch: {
    size () {
      this.page = 1
    },

    page () {
      this.getList()
    },

    total (value) {
      if (value < (this.page - 1) * this.size) {
        this.page = 1
      }
    }
  },

  async created () {
    const { userPhone } = this.$route.query
    if ( userPhone ) {
      this.form.userPhone = userPhone
    }
    this.getList()
  },

  methods: {
    // 获取应用列表
    getList () {
      const data = {
        size: this.size,
        page: this.page,
        ...this.form
      }
      this.loading = true
      GET_USER_TEMPLATES(data).then(r => {
        if (r && r.status === 200) {
          this.total = r.data.total
          this.list = r.data.list
        }
        this.loading = false
      })
    },

    // 列表类名
    tableRowClassName({row, rowIndex}) {
      return rowIndex%2 === 1 ? 'warning-row' : 'success-row'
    },

    // 页面切换
    handleCurrentChange (page) {
      this.page = page
    },

    // 编辑事件
    edit (row) {
      this.item = row
      this.editDialogVisible = true
    },

    isNeedPageDown () {
      return new Promise((resolve, reject) => {
        const page = this.page
        while (this.total <= (this.page - 1) * this.size) {
          this.page--
        }
        page < this.page ? resolve() : reject()
      })
    },

    // 重载
    reload () {
      this.editDialogVisible = false
      this.officialTemplateDialogVisible = false
      this.getList()
    },

    setOfficial (row) {
      this.item = Object.assign({ isAdd: true }, row)
      this.officialTemplateDialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.el-header {
  background-color: #ffffff;
  padding: 20px;
  padding-bottom: 0;
}
</style>
